// external imports
import React from 'react'
import { H3 } from 'quark-web'

const Header = ({ style, ...unused }) => (
    <H3
        style={{
            marginBottom: 10,
            textTransform: 'uppercase',
            fontWeight: '700',
            fontFamily: 'Lato, Arial, Helvetica, sans-serif',
            fontSize: 18,
            lineHeight: '1.2em',
            ...style
        }}
        {...unused}
    />
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js